import type { AcademicSession } from './types'

export interface TimingSettings {
  attendance_window_seconds: number
  qr_rotation_seconds: number
  attendance_token_ttl_seconds: number
}

export const DEFAULT_TIMING: Readonly<TimingSettings> = Object.freeze({
  attendance_window_seconds: 120,
  qr_rotation_seconds: 10,
  attendance_token_ttl_seconds: 30,
})

export const TIMING_FIELDS = [
  { key: 'attendance_window_seconds', label: 'Duración de asistencia', min: 30, max: 600, help: 'Cuánto tiempo permanece abierta la asistencia.' },
  { key: 'qr_rotation_seconds', label: 'Rotación del QR', min: 5, max: 60, help: 'Cada cuánto cambia el QR mostrado en el aula.' },
  { key: 'attendance_token_ttl_seconds', label: 'Validez del QR escaneado', min: 10, max: 120, help: 'Tiempo total desde su emisión durante el que el QR puede aceptarse.' },
] as const

export function validateTimingSettings(input: TimingSettings): TimingSettings {
  for (const field of TIMING_FIELDS) {
    if (!Number.isInteger(input[field.key]) || input[field.key] < field.min || input[field.key] > field.max) {
      throw new Error(`${field.label}: introduce un entero entre ${field.min} y ${field.max} segundos.`)
    }
  }
  return { attendance_window_seconds: input.attendance_window_seconds, qr_rotation_seconds: input.qr_rotation_seconds, attendance_token_ttl_seconds: input.attendance_token_ttl_seconds }
}

export function sessionTiming(session: AcademicSession): TimingSettings {
  if (session.timing) return session.timing
  const duration = ((session.closesAt ?? 0) - (session.startedAt ?? 0)) / 1000
  return { ...DEFAULT_TIMING, attendance_window_seconds: duration > 0 ? duration : DEFAULT_TIMING.attendance_window_seconds }
}
